import { CHANGE_RESULT, CHANGE_VIEW_MODE } from "../constants";

export const changeResult = (result) => ({
	type: CHANGE_RESULT,
	payload: result,
});

export const changeViewMode = (viewMode) => ({
	type: CHANGE_VIEW_MODE,
	payload: viewMode,
});
